/**
 * Custom Cursor - Premium interactive cursor with magnetic effect
 */

class CustomCursor {
  constructor() {
    this.cursor = null;
    this.cursorFollower = null;
    this.cursorTrail = [];
    this.trailLength = (navigator.hardwareConcurrency || 4) <= 4 ? 5 : 8;
    this.mousePos = { x: 0, y: 0 };
    this.cursorPos = { x: 0, y: 0 };
    this.followerPos = { x: 0, y: 0 };
    this.isHovering = false;
    this.isClicking = false;
    this.isPaused = false;
    
    // Don't initialize on touch devices
    if ('ontouchstart' in window || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    
    this.init();
  }

  init() {
    this.createCursor();
    this.createTrail();
    this.setupEventListeners();
    this.animate();
  }

  createCursor() {
    // Main cursor dot
    this.cursor = document.createElement('div');
    this.cursor.className = 'custom-cursor';
    document.body.appendChild(this.cursor);
    
    // Cursor follower ring
    this.cursorFollower = document.createElement('div');
    this.cursorFollower.className = 'cursor-follower';
    document.body.appendChild(this.cursorFollower);
  }

  createTrail() {
    for (let i = 0; i < this.trailLength; i++) {
      const trail = document.createElement('div');
      trail.className = 'cursor-trail';
      trail.style.opacity = (1 - i / this.trailLength) * 0.5;
      trail.style.transform = `scale(${1 - i / this.trailLength * 0.5})`;
      document.body.appendChild(trail);
      this.cursorTrail.push({
        element: trail,
        x: 0,
        y: 0
      });
    }
  }

  setupEventListeners() {
    document.addEventListener('mousemove', (e) => {
      this.mousePos.x = e.clientX;
      this.mousePos.y = e.clientY;
    }, { passive: true });

    document.addEventListener('mousedown', () => {
      this.isClicking = true;
      this.cursor.classList.add('clicking');
      this.cursorFollower.classList.add('clicking');
    });

    document.addEventListener('mouseup', () => {
      this.isClicking = false;
      this.cursor.classList.remove('clicking');
      this.cursorFollower.classList.remove('clicking');
    });

    document.addEventListener('visibilitychange', () => {
      this.isPaused = document.hidden;
    });

    // Magnetic effect on interactive elements
    const interactiveElements = document.querySelectorAll('a, button, .glass-card, .tech-badge, .project-card, input, textarea');
    
    interactiveElements.forEach(el => {
      el.addEventListener('mouseenter', () => {
        this.isHovering = true;
        this.cursor.classList.add('hovering');
        this.cursorFollower.classList.add('hovering');
      });
      
      el.addEventListener('mouseleave', () => {
        this.isHovering = false;
        this.cursor.classList.remove('hovering');
        this.cursorFollower.classList.remove('hovering');
      });
    });
  }

  animate() {
    if (this.isPaused) {
      requestAnimationFrame(() => this.animate());
      return;
    }

    // Smooth cursor movement
    this.cursorPos.x += (this.mousePos.x - this.cursorPos.x) * 0.2;
    this.cursorPos.y += (this.mousePos.y - this.cursorPos.y) * 0.2;
    
    // Slower follower
    this.followerPos.x += (this.mousePos.x - this.followerPos.x) * 0.1;
    this.followerPos.y += (this.mousePos.y - this.followerPos.y) * 0.1;
    
    // Update cursor position
    this.cursor.style.transform = `translate(${this.cursorPos.x}px, ${this.cursorPos.y}px)`;
    this.cursorFollower.style.transform = `translate(${this.followerPos.x}px, ${this.followerPos.y}px)`;
    
    // Update trail
    let prevX = this.cursorPos.x;
    let prevY = this.cursorPos.y;
    
    this.cursorTrail.forEach((trail, index) => {
      const speed = 0.3 - index * 0.02;
      trail.x += (prevX - trail.x) * speed;
      trail.y += (prevY - trail.y) * speed;
      trail.element.style.transform = `translate(${trail.x}px, ${trail.y}px) scale(${1 - index / this.trailLength * 0.5})`;
      prevX = trail.x;
      prevY = trail.y;
    });
    
    requestAnimationFrame(() => this.animate());
  }
}

// Initialize cursor
document.addEventListener('DOMContentLoaded', () => {
  // Delay cursor initialization
  setTimeout(() => {
    window.customCursor = new CustomCursor();
  }, 2000);
});
